import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import PersonaFi from "@/pages/PersonaFi";

export const Route = createFileRoute("/personaFi")({
  head: () => routeHead('AGAPE PersonaFi — AI Persona Validation', META_DESCRIPTIONS.personafi.en, '/personaFi'),
  component: PersonaFi,
});
